import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-on",
  "use": "device-on-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device-on\"><path d=\"M3.828 3.828a.099.099 0 0 1 0-.14 6 6 0 0 1 9.44 7.185.098.098 0 0 1-.157.021l-2.723-2.723a.1.1 0 0 1 .07-.171H12.4c.055 0 .1-.045.099-.1a4.5 4.5 0 0 0-7.61-3.152.102.102 0 0 1-.142 0l-.919-.92zM12.174 12.172c.04.039.04.102 0 .14a6 6 0 0 1-9.44-7.185.098.098 0 0 1 .157-.021l2.723 2.723a.1.1 0 0 1-.07.171H3.603c-.056 0-.1.045-.1.1a4.5 4.5 0 0 0 7.61 3.152.102.102 0 0 1 .142 0l.92.92z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol